// import bootstrapValidator from "bootstrap-validator";

/* HEAD:
 * Contains all functions for the exercise page.
 */

/* The pain per exercise is saved in this variable. */
window.pain = {};

/* global sendError,pskLength */

/*
 * Enables the next button and activates the link
 * to have the user jump to the top of the page again.
 */
function filledExerciseForm(thisElem, button) {
    thisElem.parents().find(".error").addClass("d-none");
    if (button.hasClass("disabled")) {
        button.parent().prop("href", "#start-pos");
        button.toggleClass("disabled");
    }
}

/*
 * When the DOM with all its elements are loaded.
 */
$(function () {
    /*
     * This button is pressed when the patient is done
     * with the exercise list and filled in the corresponding form.
     */
    $("#final-form").on("click", () => {
        const psk = [];
        for (let i = 0; i < pskLength; i += 1) {
            psk[i] = {
                message_id: $(`#psk${i}`).parents().siblings(".message-id").val(),
                psk_key_id: $(`#psk${i}`).parents().siblings(".psk-id").val(),
                ease: $(`#psk${i}`).val()
            };
        }

        const toSend = {
            ease: $("#ease").val(),
            psk,
            message_ids: window.message_ids
        };

        $.post({
            url: "/patient/exercises/end",
            data: toSend,
            headers: {
                "X-CSRF-TOKEN": $("meta[name='csrf-token']").attr("content")
            }
        })
            .done(_ => {
                window.location = "/patient/dashboard";
            })
            .fail(data => {
                sendError(data);
            })
            .always(() => {});
    });

    /*
     * When the sliders value have changed, disable the next button.
     */
    $(".slider").on("change", function () {
        // var button = $(this).parents().siblings(".control-wrapper").find(".next");
        const dataId = $(this).attr("id").replace("myRange", "");
        const button = $(`#done${dataId}`);
        $(this).removeClass("is-invalid");

        if ($(`.repeat-form${dataId}`).has(".is-invalid").length === 0) {
            filledExerciseForm($(this), button);
            // Makes sure that patients do not use the skip button instead of the finish button
            $(`#skip${dataId}`).addClass("disabled");
        }
    });

    $(".amount_done").on("change", function () {
        const dataId = $(this).attr("data-id");
        const button = $(`#done${dataId}`);

        if ($(this).val() === null || $(this).val() === "" || parseInt($(this).val()) < 0) {
            $(this).addClass("is-invalid");
            button.addClass("disabled");
            return;
        }
        $(this).removeClass("is-invalid");

        if ($(`.repeat-form${dataId}`).has(".is-invalid").length === 0) {
            filledExerciseForm($(this), button);
            $(`#skip${dataId}`).addClass("disabled");
        }
    });

    /*
     * When the user wants to skip this exercise, they can do so if they fill in the textarea.
     * When a value is entered, the finish exercise button will be made available to click.
     */
    $(".not-completed").on("keyup", function () {
        const dataId = $(this).attr("id").replace("not-completed", "");
        const button = $(`#done${dataId}`);
        // var button = $(this).parent().siblings(".control-wrapper").find(".next");

        if ($(this).val() && $(`.repeat-form${dataId}`).has(".is-invalid").length === 0) {
            filledExerciseForm($(this), button);
            // text.removeClass("disabled")
        } else if ($(`#myRange${dataId}`).hasClass("is-invalid")) {
            button.addClass("disabled");
            button.parent().prop("href", "#");
        }
    });

    // $("#collapse-all-exercises").on("click", function() {
    //     const target = $(this).data("target");
    //     if ($(target).hasClass("hidden")) {
    //         $(target).removeClass("hidden");
    //     } else {
    //         $(target).addClass("hidden");
    //     }
    // })
});
